export function publishToast(subject, body = '', icon = 'notifications') {
    window.dispatchEvent(new CustomEvent('toast-notification', {
        detail: {
            subject: subject || '',
            body,
            icon
        }
    }));
}